import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <h1 className="text-9xl font-bold text-yellow-500">404</h1>
        <h2 className="text-3xl font-bold text-white mt-4">Page Not Found</h2>
        <p className="text-gray-400 mt-4 mb-8">
          Oops! The page you're looking for doesn't exist. But don't worry,
          there's still plenty of great food waiting for you!
        </p>

        <div className="space-y-4">
          <Link
            to="/"
            className="block w-full bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-6 rounded-lg transition-colors"
          >
            Back to Home
          </Link>

          <div className="grid grid-cols-2 gap-4">
            <Link
              to="/menu"
              className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
            >
              View Menu
            </Link>
            <a
              href="https://order.toasttab.com/online/ultimate-bar-and-grill-455-east-plaza-drive"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-800 hover:bg-gray-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors"
            >
              Order Online
            </a>
          </div>
        </div>

        <div className="mt-12 text-gray-500">
          <p>Need help? Call us at</p>
          <a href="tel:+17047999771" className="text-yellow-500 font-bold text-xl hover:text-yellow-400">
            (704) 799-9771
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
